var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoters100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1375_384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 99,
    height: 99,
    rx: 15,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2814 73C32.085 73 31.0724 72.6 30.2434 71.8C29.4145 71 29 70.0227 29 68.8681V45.1318C29 43.9772 29.4145 42.9999 30.2434 42.1999C31.0724 41.3999 32.085 40.9999 33.2814 40.9999H43.2106V37.1319C43.2106 35.9773 43.625 35 44.454 34.2C45.2829 33.4 46.2956 33 47.492 33H55.508C56.7044 33 57.7171 33.4 58.546 34.2C59.375 35 59.7894 35.9773 59.7894 37.1319V40.9999H69.7186C70.915 40.9999 71.9276 41.3999 72.7566 42.1999C73.5855 42.9999 74 43.9772 74 45.1318V68.8681C74 70.0227 73.5855 71 72.7566 71.8C71.9276 72.6 70.915 73 69.7186 73H33.2814ZM46.7631 40.9999H56.2369V37.1319C56.2369 36.956 56.1609 36.7948 56.0091 36.6483C55.8573 36.5018 55.6902 36.4285 55.508 36.4285H47.492C47.3098 36.4285 47.1427 36.5018 46.9909 36.6483C46.8391 36.7948 46.7631 36.956 46.7631 37.1319V40.9999ZM70.4474 59.8571H57.421V63.8571H45.579V59.8571H32.5526V68.8681C32.5526 69.0439 32.6285 69.2051 32.7803 69.3517C32.9322 69.4982 33.0992 69.5715 33.2814 69.5715H69.7186C69.9008 69.5715 70.0678 69.4982 70.2197 69.3517C70.3715 69.2051 70.4474 69.0439 70.4474 68.8681V59.8571ZM49.1316 60.4286H53.8684V55.8571H49.1316V60.4286ZM32.5526 56.4286H45.579V52.4286H57.421V56.4286H70.4474V45.1318C70.4474 44.956 70.3715 44.7948 70.2197 44.6482C70.0678 44.5017 69.9008 44.4285 69.7186 44.4285H33.2814C33.0992 44.4285 32.9322 44.5017 32.7803 44.6482C32.6285 44.7948 32.5526 44.956 32.5526 45.1318V56.4286Z",
    fill: "#044535"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1375_384",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1375_384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1375_384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoters100);
export default __webpack_public_path__ + "static/media/promoters100.7b9b67812132b9d5071ada1c7d26c700.svg";
export { ForwardRef as ReactComponent };